import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
    StyledBottomDrawer,
    MoreMenuHeader,
    StyledCloseButton,
    MenuItemCard,
    MenuItemLabel,
} from '../styles/navigationStyles';
import { NavigationIcon } from './NavigationItem';
import { ARIA_LABELS } from '../constants/navigationConfig';
import { NAVIGATION_DIMENSIONS } from '../constants/navigationTheme';

/**
 * Drawer com itens extras do menu mobile
 */
const MoreDrawer = ({ open, onClose, items, onItemClick }) => {
    return (
        <StyledBottomDrawer
            anchor="bottom"
            open={open}
            onClose={onClose}
            aria-labelledby="more-menu-title"
        >
            <MoreMenuHeader>
                <StyledCloseButton
                    onClick={onClose}
                    size="small"
                    aria-label={ARIA_LABELS.CLOSE_MORE_MENU}
                >
                    <CloseIcon />
                </StyledCloseButton>
            </MoreMenuHeader>

            <Grid container spacing={2} role="menu" aria-label={ARIA_LABELS.MORE_OPTIONS}>
                {items.map((item) => (
                    <Grid item xs={6} key={item.id}>
                        <MenuItemCard
                            selected={false}
                            onClick={() => onItemClick(item)}
                            role="menuitem"
                            tabIndex={0}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    onItemClick(item);
                                }
                            }}
                            aria-label={item.label}
                            data-testid={`moreMenuItem_${item.label}_btn`}
                        >
                            <NavigationIcon item={item} />
                            <MenuItemLabel>{item.label}</MenuItemLabel>
                        </MenuItemCard>
                    </Grid>
                ))}
            </Grid>
        </StyledBottomDrawer>
    );
};

MoreDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.elementType.isRequired,
            route: PropTypes.string.isRequired,
        })
    ).isRequired,
    onItemClick: PropTypes.func.isRequired,
};

export default MoreDrawer;